module.exports = __webpack_public_path__ + "static/media/tax.7724c506.svg";